import { StyleCache, getAnimationNames } from '@sail/engine';
export const pluginsAnimation = {
    animation (value, set) {
        const animationNames = getAnimationNames(value);
        animationNames.forEach((animationName)=>{
            const intent = StyleCache.get(animationName);
            if (intent) {
                set.dependency(intent);
            }
        });
        set.property('animation', value);
    }
};

//# sourceMappingURL=pluginsAnimation.js.map